import { api } from 'app/app.api';

import {
  DeleteOrganizationStorageApiArg,
  DeleteOrganizationStorageApiResponse,
  GetOrganizationStorageApiArg,
  GetOrganizationStorageApiResponse,
  SetOrganizationStorageApiArg,
  SetOrganizationStorageApiResponse,
} from './types/organizationStorageApi.types';

export const organizationStorageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readOrganizationStorage: builder.query<
      GetOrganizationStorageApiResponse,
      GetOrganizationStorageApiArg
    >({
      query: ({ keys = [] }) => ({
        version: 4,
        path: 'organization-storage',
        params: { keys },
      }),
    }),
    setOrganizationStorage: builder.mutation<
      SetOrganizationStorageApiResponse,
      SetOrganizationStorageApiArg
    >({
      query: (body) => ({
        version: 4,
        path: 'organization-storage',
        method: 'PATCH',
        body,
      }),
      async onQueryStarted(patch, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          organizationStorageApi.util.updateQueryData(
            'readOrganizationStorage',
            {},
            (draft) => {
              Object.entries(patch).forEach(([key, value]) => {
                if (value === null) {
                  delete draft[key];
                } else {
                  draft[key] = value;
                }
              });
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    removeOrganizationStorageByKey: builder.mutation<
      DeleteOrganizationStorageApiResponse,
      DeleteOrganizationStorageApiArg
    >({
      query: ({ key }) => ({
        version: 4,
        path: `organization-storage/${key}`,
        method: 'DELETE',
      }),
      async onQueryStarted({ key }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          organizationStorageApi.util.updateQueryData(
            'readOrganizationStorage',
            {},
            (draft) => {
              delete draft[key];
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});
